import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useCompanyCore } from '../../../core/modules/company';
import { Avatar, Button } from '@mui/material';
import { COMPANIES } from '../../../core/router/routes';
import { useCallback, useState } from 'react';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { useNavigationCore } from '../../../core/router/navigation';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t } = useTranslation();
  const { goToCompanies } = useNavigationCore();
  const { company, deleteCompany } = useCompanyCore();

  const [loading, setLoading]  = useState(false);

  const onChangingStatus = useCallback(() => {
    Swal.fire({
      title: t('alert.sure.title'),
      text: t('alert.sure.delete.company', { company: company?.name }),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t('alert.sure.confirm.button'),
      cancelButtonText: t('alert.sure.cancel.button'),
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        deleteCompany(company?.id!, goToCompanies);
      }
    });
  }, [company?.id, company?.name, deleteCompany, goToCompanies, t]);

  return (
    <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between space-y-8 sm:space-y-0 py-32 px-24 md:px-32">
      <div className="flex flex-col items-center sm:items-start space-y-8 sm:space-y-0 w-full sm:max-w-full min-w-0">
        <Typography
          className="flex items-center sm:mb-12"
          component={Link}
          role="button"
          to={COMPANIES}
          color="inherit"
        >
          <ArrowBackOutlinedIcon />
          <span className="flex mx-4 font-medium">Compañías</span>
        </Typography>

        <div className="flex items-center max-w-full">
          <div className="hidden sm:flex">
            {company?.selectedAvatar ? (
              <Avatar className="w-112 h-112" src={company.selectedAvatar}></Avatar>
            ) : (
              <Avatar className="w-84 h-84">{company?.name[0]}</Avatar>
            )}
          </div>
          <div className="flex flex-col items-center sm:items-start min-w-0 mx-8 sm:mx-16">
            <Typography className="text-16 sm:text-20 truncate font-semibold">
              {company?.name}
            </Typography>
            <Typography variant="caption" className="font-medium">
              Detalles de la compañía
            </Typography>
          </div>
        </div>
      </div>
      <div className="flex">
        <Button
          className="whitespace-nowrap mx-4"
          variant="contained"
          color="error"
          startIcon={<BlockOutlinedIcon />}
          onClick={onChangingStatus}
          disabled={loading}
        >
          Eliminar
        </Button>
      </div>
    </div>
  );
};

export default Header;
